import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './DateInput.css'
import {asField} from '$src/common/forms'
import {SingleDatePicker} from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import 'react-dates/initialize'

interface Props {
  css?: any
  type?: 'text' | 'password'
  name: string
  label: string
  placeholder?: string
  value: any
  onChange: (v: any) => void
}

@observer
export default class DateInput extends Component<Props, {focused: boolean}> {
  static Field: any
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {focused: false}
  }
  _onChange = (e: any) => {
    this.props.onChange(e.target.value)
  }
  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container')}>
        <label {...classes('label')}>{props.label}</label>
        <SingleDatePicker
          // @ts-ignore
          date={this.props.value || null}
          onDateChange={props.onChange}
          focused={this.state.focused}
          onFocusChange={({focused}: {focused: boolean}) =>
            this.setState({focused})
          }
          noBorder={true}
          isOutsideRange={() => false}
          id="singleDatePicker"
        />
      </div>
    )
  }
}

DateInput.Field = asField()(DateInput)



// WEBPACK FOOTER //
// ./src/common/DateInput.tsx